import { restHeartClient } from '..'

export function putObject(api: string, data: any) {
	return restHeartClient.put(api, data)
}

export function putCollectionObject(db: string, collection: string, data: any) {
	return restHeartClient.put(`${db}/${collection}/`, data)
}
